module.exports = __webpack_public_path__ + "img/searchsvg.40b321da.svg";